import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DeprecatedModalFormComponent } from '@app/components';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { TrainingProgramRecordsTable } from '@app/modules/training/services/tables/training-program-records/training-program-records.table';
import { TrainingModuleMenuService } from '@app/modules/training/services/training-module-menu.service';
import { AuthService } from '@app/services';
import { getHelpCentreArticle } from '@app/types/translatable.type';
import { DeleteRecordModal, TrainingRecordReminderForm } from '@forms/employees/components';
import { TrainingProgramRecord } from '@models/training/training-program-record.model';

@Component({
    templateUrl: './training-program-records.template.html',
    styleUrls: ['./training-program-records.style.scss'],
})
export class TrainingProgramRecordsView implements OnInit {
    @ViewChild('deleteRecordModal') deleteRecord: DeleteRecordModal;
    @ViewChild('sendReminderForm') sendReminderForm: TrainingRecordReminderForm;
    @ViewChild('trainingRecordFormModal') trainingRecordFormModal: DeprecatedModalFormComponent;

    isLoading = false;
    training: TrainingProgramRecord[] = [];
    record: TrainingProgramRecord;
    learnMoreUrl = getHelpCentreArticle('360049374073');

    constructor(
        public table: TrainingProgramRecordsTable,
        protected auth: AuthService,
        protected route: ActivatedRoute,
        public trainingModuleMenuService: TrainingModuleMenuService
    ) {
        this.table.onLoading.subscribe((isLoading) => (this.isLoading = isLoading));
        if (this.route.snapshot.data?.excludeSelf) {
            this.table.excludedEmployee = this.auth.employee;
        }
        this.table.init();
    }

    ngOnInit(): void {}

    menuAction(event: MenuColumnEvent): void {
        const { menuItem, data } = event;
        this.record = data as TrainingProgramRecord;

        switch (menuItem.event) {
            case 'edit':
                this.onEdit();
                break;
            case 'delete':
                this.deleteRecord.confirm(this.record);
                break;
            case 'remind':
                this.sendReminderForm.open(this.record);
                break;
            case 'record':
                this.onRecord();
                break;
        }
    }

    private onEdit(): void {
        this.trainingRecordFormModal.headerText = `Edit ${this.record.trainingProgram.name}`;
        this.trainingRecordFormModal.show();
    }

    private onRecord(): void {
        this.trainingRecordFormModal.headerText = `Complete ${this.record.trainingProgram.name}`;
        this.trainingRecordFormModal.show();
    }
}
